export default __webpack_public_path__ + "static/media/doc1.a11baec4.jpg";